import React from 'react';
import ReactQueryParams from "react-query-params";
import {Col, Button, Row, Badge, ButtonToolbar} from 'reactstrap';

import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from "../../../modules/environment";
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import * as http from '../../../modules/http';
import Alert from '../../../components/Alert';
import Modal from './Modal'
import RadioButtonField from "../../../components/RadioButton";
import NumberFormat from 'react-number-format';
import Cards from 'react-credit-cards';
import ChatCard from '../../../components/Chat/components/ChatCard'
import DropZoneField from '../../../components/DropZoneField';
import moment from 'moment';
import {round10} from "../../../modules/common"

import {
    eq_order_update_field,
    eq_order_update,
    fetchEquipmentDataForce
} from '../../../redux/actions/EquipmentActions';


class EquipOrderManageJson extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            warning: '',
            error: false,
            saved: false,
            success: false,

            comment: "",
            files_front: props.itemOrderInEdit.payment.payType === 2 ? [[{preview: environment.getServerBasePath() + '/equip/equip_order_download?equipID=' + props.itemOrderInEdit.id + '&side=front'}]] : [[]],
            filesBase64_front: [[]],
            filesInfo_front: [{}],

            files_rear: props.itemOrderInEdit.payment.payType === 2 ? [[{preview: environment.getServerBasePath() + '/equip/equip_order_download?equipID=' + props.itemOrderInEdit.id + '&side=rear'}]] : [[]],
            filesBase64_rear: [[]],
            filesInfo_rear: [{}]
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchSalesDataIfNeeded());
    }

    simNumChanged = (index, value) => {
        let tmp = this.props.itemOrderInEdit.orders.slice();

        //mp[index].equipNums = value;
        tmp[index].storeOrderNums = value;
        this.props.dispatch(eq_order_update_field('orders', tmp));
    };

    isDirectCard = () => {
        let res = false;
        let cardNum = this.props.itemOrderInEdit.payment.cardNumber;

        if (cardNum !== '') {
            if (cardNum.startsWith('458042') || cardNum.startsWith('458047') || cardNum.startsWith('45808000') ||
                cardNum.startsWith('458052') || cardNum.startsWith('458047') || cardNum.startsWith('45808300') ||
                cardNum.startsWith('4200') || cardNum.startsWith('532614') || cardNum.startsWith('4147')) {
                res = true;
            }
        }
        return res;
    };

    cardFocusChanged = (type) => {
        let cardFocus = "";
        switch (type) {
            case "cardNumber":
                cardFocus = "number";
                break;
            case "validationDate":
                cardFocus = "expiry";
                break;
            case "cvv":
                cardFocus = "cvc";
                break;
            default:
                cardFocus = "";
                break;
        }
        this.setState({cardFocus: cardFocus});
    };

    limit = (val, max) => {
        if (val.length === 1 && val[0] > max[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val > max) {
                val = max;
            }
        }

        return val;
    };

    cardExpiry = (val) => {
        let month = this.limit(val.substring(0, 2), '12');
        let year = val.substring(2, 4);

        return month + (year.length ? '/' + year : '');
    };

    paymentDetailsChanged = (type, value, once) => {

        let updatedPaymentDetails = {...this.props.itemOrderInEdit.payment};

        updatedPaymentDetails[type] = value;

        this.props.dispatch(eq_order_update_field('payment', updatedPaymentDetails));
    };

    getStatusColor = (status) => {
        if (status === 0)
            return "warning";
        else if (status === 1)
            return "danger";
        else if(status === 2)
            return "success";
        /*else if(status === 3)
            return "other";*/
        else
            return "primary";
    };

    getStatusText = (status) => {
        if(status === 0)
            return TextManager.getCurrentTextResource().Text.new;
        else if (status === 1)
            return TextManager.getCurrentTextResource().Text.inactive;
        else if(status === 2)
            return TextManager.getCurrentTextResource().Text.active;
        /*else if(status === 3)
            return 'בטיפול';*/
        else
            return '';
    };

    changeStatusStateMachine = (currentStatus) => {
        if(currentStatus === 2)
            return 0;
        else if(currentStatus === 0)
            return 1;
        else if(currentStatus === 1)
            return 2;
        else
            return 2;
    };

    changeStatus = (isAdmin) => {

        if(isAdmin) {
            let newStatus = this.changeStatusStateMachine(this.props.itemOrderInEdit.account);

            this.props.dispatch(eq_order_update_field('account', newStatus));
        }
    };

    updateComment = (value, type) => {
        this.setState({comment: value});
    };

    selectDoc_Front = (files, index) =>{

        if (files.length === 0) {
            let tmp = this.state.files_front;
            tmp.splice(index, 1);

            let res = this.state.filesBase64_front;
            res.splice(index, 1);

            let info = this.state.filesInfo_front;
            info.splice(index, 1);
            this.setState({files_front: tmp, filesBase64_front: res, filesInfo_front: info});
        }
        else {
            // Saving name and size
            let tmpInfo = this.state.filesInfo_front;
            let fr = new FileReader();
            fr.onload = function () {
                let img = new Image();
                img.onload = function () {
                    tmpInfo[index] = {name: files[0].name, size: img.width + "x" + img.height};
                    tmpInfo.push({});
                };
                img.src = fr.result;
            };
            fr.readAsDataURL(files[0]);

            // Saving doc
            this.getFilesBase64Rec(files, [], 0,
                (result) => {
                    let tmp = this.state.files_front;
                    tmp[index] = files;
                    tmp.push([]);

                    let res = this.state.filesBase64_front;
                    res[index] = result;
                    res.push([]);
                    this.setState({files_front: tmp, filesBase64_front: res, filesInfo_front: tmpInfo});
                });
        }

    };

    selectDoc_Rear = (files, index) =>{

        if (files.length === 0) {
            let tmp = this.state.files_rear;
            tmp.splice(index, 1);

            let res = this.state.filesBase64_rear;
            res.splice(index, 1);

            let info = this.state.filesInfo_rear;
            info.splice(index, 1);
            this.setState({files_rear: tmp, filesBase64_rear: res, filesInfo_rear: info});
        }
        else {
            // Saving name and size
            let tmpInfo = this.state.filesInfo_rear;
            let fr = new FileReader();
            fr.onload = function () {
                let img = new Image();
                img.onload = function () {
                    tmpInfo[index] = {name: files[0].name, size: img.width + "x" + img.height};
                    tmpInfo.push({});
                };
                img.src = fr.result;
            };
            fr.readAsDataURL(files[0]);

            // Saving doc
            this.getFilesBase64Rec(files, [], 0,
                (result) => {
                    let tmp = this.state.files_rear;
                    tmp[index] = files;
                    tmp.push([]);

                    let res = this.state.filesBase64_rear;
                    res[index] = result;
                    res.push([]);
                    this.setState({files_rear: tmp, filesBase64_rear: res, filesInfo_rear: tmpInfo});
                });
        }

    };

    getFilesBase64Rec(fileObjs, filesBase64, index, callback) {

        this.getBase64(fileObjs[index], (result) => {

            filesBase64.push(result);
            if (index < fileObjs.length - 1) {
                this.getFilesBase64Rec(fileObjs, filesBase64, index + 1, callback)
            }
            else {
                callback(filesBase64);
            }
        });
    }

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.warn('Error: ', error);
        };
    }

    /*getTotalPriceStr = () => {
        let res = '';
        let totalPrice = 0;
        let isFirst = true;

        let data = this.props.itemOrderInEdit.orders;
        for(let i in this.props.itemOrderInEdit.orders) {
            let price = round10(parseFloat(data[i].price) + parseFloat(data[i].price) * (parseFloat(data[i].profit) * 0.01), -1);
            let priceMultiCount = round10(parseInt(data[i].storeOrderNums) * price, -1);

            if(!isFirst) {

                res  += " + "
            }
            res  += data[i].equipName + ": " + parseInt(data[i].storeOrderNums) + "*" + priceMultiCount + "₪";
            totalPrice = totalPrice + priceMultiCount;

            if(isFirst) isFirst = false;
        }

        res += " = " + totalPrice + "₪";

        return res;
    };*/

    getTotalPriceStr = () => {
        let res = '';
        let totalPrice = 0;
        let isFirst = true;

        let data = this.props.itemOrderInEdit.orders;
        //for(let i in this.props.itemOrderInEdit.orders) {
        for(var i = this.props.itemOrderInEdit.orders.length - 1; i >= 0; i--) {
            let price = round10(parseFloat(data[i].price) + parseFloat(data[i].price) * (parseFloat(data[i].profit) * 0.01), -1);
            let priceMultiCount = round10(parseInt(data[i].storeOrderNums) * price, -1);

            if(!isFirst) {

                res  += " + "
            }
            res  +=  priceMultiCount + " ₪";
            totalPrice = totalPrice + priceMultiCount;

            if(isFirst) isFirst = false;
        }

        //let final = "₪ לפני מעמ" +  totalPrice +  " = " + res + " :סהכ להזמנה זו ";
        let final = " סהכ להזמנה זו " + ":" + res +  " = " + totalPrice + " ₪" + " לפני מעמ ";

        return final;
    };

    saveOrders = () => {

        /*if(this.state.order === '') {
            this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectProvider});
            return;
        }*/

        let chat = this.props.itemOrderInEdit.chat ? this.props.itemOrderInEdit.chat : [];

        if (this.state.comment !== '') {
            chat.push({
                name: this.props.userData.data.name, message: this.state.comment, date: moment().format('llll'),
                isStore: (this.props.userData.data.isManager !== true && this.props.userData.data.isAdmin !== true) ? 1 : 0
            })
        }

        if(this.props.itemOrderInEdit.payment.payType === 2) {

            let checkFront = {
                name: (this.state.filesInfo_front[0] && this.state.filesInfo_front[0].name) ? this.state.filesInfo_front[0].name : "",
                size: (this.state.filesInfo_front[0] && this.state.filesInfo_front[0].size) ? this.state.filesInfo_front[0].size : "",
                data: (this.state.filesBase64_front[0] && this.state.filesBase64_front[0][0]) ? this.state.filesBase64_front[0][0] : ""
            };

            let checkRear = {
                name: (this.state.filesInfo_rear[0] && this.state.filesInfo_rear[0].name) ? this.state.filesInfo_rear[0].name : "",
                size: (this.state.filesInfo_rear[0] && this.state.filesInfo_rear[0].size) ? this.state.filesInfo_rear[0].size : "",
                data: (this.state.filesBase64_rear[0] && this.state.filesBase64_rear[0][0]) ? this.state.filesBase64_rear[0][0] : ""
            };

            this.props.itemOrderInEdit.payment.checkFront = checkFront;
            this.props.itemOrderInEdit.payment.checkRear = checkRear;
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            id: this.props.itemOrderInEdit.id,
            storeId: this.props.itemOrderInEdit.storeId,
            storeName: this.props.itemOrderInEdit.storeName,
            date: this.props.itemOrderInEdit.date,
            updateDate: this.props.itemOrderInEdit.updateDate,
            lines: this.props.itemOrderInEdit.lines,
            account: this.props.itemOrderInEdit.account,
            provided: this.props.itemOrderInEdit.provided,
            orders: this.props.itemOrderInEdit.orders,
            payment: this.props.itemOrderInEdit.payment,
            chat: chat,
            managerName: this.props.itemOrderInEdit.managerName
        };

        http.postToServer(
            'equip/equip_order_update',
            storeData,
            (response) => {
                this.setState({saving: false, error: false});

                this.props.dispatch(eq_order_update(response.data));

                this.props.dispatch(fetchEquipmentDataForce(this.queryParams));

                this.props.onClose();
            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})
            }
        );
    };

    render() {

        /*let colorAcc = this.props.itemOrderInEdit.account === 0 ? 'warning' : 'success';
        let textAcc = this.props.itemOrderInEdit.account === 0 ? 'לא' : 'כן';*/

        let status = this.props.itemOrderInEdit.provided === 0 ? 'לא סופקה' : 'סופקה הסחורה';
        let color = this.props.itemOrderInEdit.provided === 0 ? 'warning' : 'success';

        let isDirect = this.isDirectCard();

        const isAdding = this.props.itemOrderInEdit.id === 0;

        let isAdmin = this.props.userData.data.isAdmin || (this.props.userData.data.id === 795);

        let isManager = this.props.userData.data.isManager;

        let price = this.getTotalPriceStr();

        let isForManagers = this.props.managers;

        return (

            <div className="catalog-items__wrap">
                {this.state.warning !== '' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span style={{float: 'right'}}
                                 className='bold-text'>{this.state.warning}</span>
                        </p>
                    </Alert>
                </Row>}
                {this.state.error &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }
                {this.state.success &&
                <Modal color='success' title={TextManager.getCurrentTextResource().Text.wellDone} noCancel
                       message={TextManager.getCurrentTextResource().Text.dealSucceeded}
                       approve={() => this.setState({saved: true})}/>
                }

                {isAdmin && !isForManagers && <div className='card__title'>
                    <h5 className='bold-text'>{'שים לב החנות מכרה חודש קודם והחודש ' + this.props.itemOrderInEdit.lines + ' קווים פעילים בלבד'}</h5>
                </div>}

                {(isAdmin || isManager) && <form className='form form--horizontal'>
                    {!isForManagers && <div className="form__form-group">
                        <label className="form__form-group-label">צורת תשלום</label>
                        <div className={"radio-button__group"}>

                            <RadioButtonField name="bank" value={2}
                                              onChange={(value) => {
                                                  this.paymentDetailsChanged("payType", 2);
                                              }}
                                              label="צ''ק"
                                              radioValue={this.props.itemOrderInEdit.payment.payType}/>

                            <RadioButtonField name="credit" value={1}
                                              label='כרטיס אשראי'
                                              onChange={(value) => {
                                                  //this.props.dispatch(orders_eq_order_update_field('account', 1));
                                                  this.paymentDetailsChanged("payType", 1);
                                              }}
                                              radioValue={this.props.itemOrderInEdit.payment.payType}/>

                            <RadioButtonField name="credit" value={0}
                                              label='התחשבנות'
                                              onChange={(value) => {
                                                  //this.props.dispatch(orders_eq_order_update_field('account', 0));
                                                  this.paymentDetailsChanged("payType", 0);
                                              }}
                                              radioValue={this.props.itemOrderInEdit.payment.payType}/>
                        </div>
                    </div>}

                    {this.props.itemOrderInEdit.payment.payType === 1 &&
                    <div className="form__form-group">
                        {isDirect && <Row style={{flexDirection: 'row-reverse'}}>
                            <Alert color='warning' className='alert--bordered' icon>
                                <p><span className='bold-text'>שים לב ❤️ זה כרטיס דיירקט</span></p>
                            </Alert>
                        </Row>}

                        <div className="form__form-group">
                            <Row>
                                <Col md={9}>
                                    <form className='form form--horizontal'>
                                        <div className='form__form-group'>
                                            <label
                                                className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.customerName}</label>
                                            <div className='form__form-group-field'>
                                                <input
                                                    style={{backgroundColor: 'white'}}
                                                    dir={"auto"}
                                                    value={this.props.itemOrderInEdit.payment.name}
                                                    onChange={(event) => this.paymentDetailsChanged("name", event.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className='form__form-group'>
                                            <label
                                                className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.id}</label>
                                            <div className='form__form-group-field'>
                                                <input
                                                    style={{backgroundColor: 'white'}}
                                                    dir={"auto"}
                                                    value={this.props.itemOrderInEdit.payment.id}
                                                    onChange={(event) => this.paymentDetailsChanged("id", event.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </div>

                        <div className="form__form-group">
                            <Row style={{flexDirection: 'row-reverse'}}>

                                <Col sm={9}>
                                    <span
                                        className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.cardNumber}</span>
                                    <div className="form__form-group-field">
                                        <NumberFormat
                                            //format="#### #### #### ####"
                                            format="################"
                                            style={{backgroundColor: 'white'}}
                                            value={this.props.itemOrderInEdit.payment.cardNumber || ''}
                                            name="cardNumber"
                                            onFocus={() => this.cardFocusChanged("cardNumber")}
                                            placeholder="0000 0000 0000 0000"
                                            type="text"
                                            onChange={(event) => {
                                                this.paymentDetailsChanged('cardNumber', event.target.value);
                                            }
                                            }
                                        />
                                    </div>
                                    <span
                                        className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.validationDate}</span>
                                    <div className="form__form-group-field">
                                        <NumberFormat
                                            format={this.cardExpiry}
                                            style={{backgroundColor: 'white'}}
                                            value={this.props.itemOrderInEdit.payment.validationDate || ""}
                                            name="validationDate"
                                            required
                                            onFocus={() => this.cardFocusChanged("validationDate")}
                                            placeholder="MM/YY"
                                            data-valid-example="05/18"
                                            onChange={(event) =>
                                                this.paymentDetailsChanged('validationDate', event.target.value)}
                                        />
                                    </div>
                                    <span
                                        className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.cvv}</span>
                                    <div className="form__form-group-field">
                                        <input
                                            dir={"auto"}
                                            value={this.props.itemOrderInEdit.payment.cvv || ''}
                                            style={{backgroundColor: 'white'}}
                                            name="cvv"
                                            /*minLength={(this.state.formFields.paymentDetails.cardType === "mastercard"
                                                || this.state.formFields.paymentDetails.cardType === "visa") ? 3 : 4}
                                            maxLength={this.state.formFields.paymentDetails.cardType === "mastercard"
                                            || this.state.formFields.paymentDetails.cardType === "visa" ? 3 : 4}*/
                                            type="text"
                                            autoComplete={"on"}
                                            required
                                            onFocus={() => this.cardFocusChanged("cvv")}
                                            onChange={(event) =>
                                                this.paymentDetailsChanged('cvv', event.target.value)}
                                        />
                                    </div>
                                </Col>

                                <Col sm={3}>
                                    <div className="form__form-group-field">
                                        <Cards style={{margin: 'none'}}
                                               preview={true}
                                               number={this.props.itemOrderInEdit.payment.cardNumber}
                                               name={""}
                                               expiry={this.props.itemOrderInEdit.payment.validationDate || ""}
                                               cvc={this.props.itemOrderInEdit.payment.cvv}
                                               focused={this.state.cardFocus}
                                               placeholders={{
                                                   name: ''
                                               }}
                                               callback={(event, isValid) =>
                                                   this.paymentDetailsChanged('cardType', event.issuer)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>}

                    {this.props.itemOrderInEdit.payment.payType === 2 &&
                        <Row style={{display: 'contents', flexDirection: 'row-reverse'}}>
                            <Col md={6}>
                                <div className='card__title'>
                                    <h5 className='bold-text'>צילום הצ'ק מאחורה</h5>
                                </div>
                                <div>
                                    <DropZoneField customHeight
                                                   multi={false}
                                                   files={this.state.files_rear[0]}
                                                   onChange={(files) => this.selectDoc_Rear(files, 0)}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className='card__title'>
                                    <h5 className='bold-text'>צילום הצ'ק מקדימה</h5>
                                </div>
                                <div>
                                    <DropZoneField customHeight
                                                   multi={false}
                                                   files={this.state.files_front[0]}
                                                   onChange={(files) => this.selectDoc_Front(files, 0)}
                                    />
                                </div>
                            </Col>
                        </Row>
                   }

                    {this.props.itemOrderInEdit.payment.payType === 2 &&
                    <div className='form__form-group'/>}


                    {!isForManagers && <div className='form__form-group'>
                        <label
                            className='form__form-group-label'>סטטוס תשלום</label>
                        <div className='form__form-group-field'>
                            <Badge color={this.getStatusColor(this.props.itemOrderInEdit.account)} style={isAdmin ? {cursor: 'pointer'} : {}}
                                   onClick={() => this.changeStatus(isAdmin)}>
                                {this.getStatusText(this.props.itemOrderInEdit.account)}
                            </Badge>
                        </div>
                    </div>}

                    <div className='form__form-group'>
                        <label
                            className='form__form-group-label'>סטטוס</label>
                        <div className='form__form-group-field'>
                            <Badge color={color} style={{cursor: 'pointer'}}
                                   onClick={() => this.props.dispatch(eq_order_update_field('provided', this.props.itemOrderInEdit.provided === 0 ? 1 : 0))}>
                                {status}
                            </Badge>
                        </div>
                    </div>
                </form>}


                <div className="catalog-items" style={{paddingRight: '50px'}}>
                    <style>
                        {`
                        .catalog-item {
                        width: calc(20% - 47px);
                        }
                        .catalog-item__img-wrap {
                        height: auto
                        }
                    `}
                    </style>
                    {this.props.itemOrderInEdit.orders.map((order, i) => {

                        let currStore = 'במלאי ';

                        if(this.props.equipStore) {
                            let inStore = this.props.equipStore.find(e => e.serial === order.serialNum);
                            if (inStore && inStore !== undefined) {
                                currStore = currStore + inStore.count;
                            } else {
                                currStore = currStore + 0;
                            }
                        }
                        else {
                            currStore = currStore + 0;
                        }

                        let price = round10((parseFloat(order.price) + parseFloat(order.price) * (parseFloat(order.profit) * 0.01)), -1);
                        let priceTotal = round10(parseInt(order.storeOrderNums) * price, -1);

                        let priceTotalStr = "₪" + priceTotal + " =  ₪" + price  + " * ";

                        return (
                            <div className="catalog-item" key={i}
                                 style={{padding: '10px 10px', height: '250', marginRight: '10px'}}>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/equip/equip_download?equipID=' + order.equipId}
                                         alt="catalog-item-img"/>
                                </div>
                                <div className="catalog-item__info">
                                    <h5 className="catalog-item__title"
                                        style={{textAlign: 'center'}}>{order.equipName}</h5>
                                    <h5 className="catalog-item__title">{order.serialNum}</h5>
                                    <h5 className="catalog-item__title">{order.text}</h5>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    {!isForManagers && <span className="form__form-group-label" style={(isAdmin || isManager) ? {paddingLeft: '10px'} : {paddingRight: '10px'}}>
                                        {priceTotalStr}
                                    </span>}
                                    <input
                                        value={order.storeOrderNums}
                                        dir={"auto"}
                                        style={(order.isHandled || (!isAdmin && !isManager)) ? {backgroundColor: '#DCDCDC', width: '70px'} : {backgroundColor: '#f0f8f0', width: '70px'}}
                                        name="simNumber"
                                        type="text"
                                        disabled={order.isHandled || (!isAdmin && !isManager)}
                                        onChange={(event) =>
                                            this.simNumChanged(i, event.target.value)}
                                    />
                                    <span className="form__form-group-label" style={{paddingLeft: '10px'}}>
                                        כמות
                                    </span>
                                    {(isAdmin || isManager) && <div className="form__form-group-label" style={{paddingRight: '10px'}}>
                                        {currStore}
                                    </div>}
                                </div>
                            </div>
                        )
                    })
                    }
                </div>

                {(isAdmin || isManager) && !isForManagers && <div className='card__title' style={{paddingRight: '50px'}}>
                    <h4 className='bold-text'>{price}</h4>
                </div>}

                <Row>
                    <Col md={6}>
                        <form className='form form--horizontal'>
                            <div className='form__form-group'>
                            </div>

                            <div className="form__form-group" dir="rtl">
                                <ChatCard
                                    type={1}
                                    userId={isAdding ? 0 : this.props.itemOrderInEdit.id}
                                    chat={this.props.itemOrderInEdit.chat}
                                    currentUser={this.props.userData.data}
                                    comment={this.state.comment}
                                    deleteMessage={this.deleteMessage}
                                    updateComment={this.updateComment}
                                    background={'lightgrey'}
                                />
                            </div>
                        </form>
                    </Col>
                </Row>

                <ButtonToolbar className="form__button-toolbar" style={{flexDirection: 'row-reverse'}}>
                    <Button color='primary' onClick={() => this.saveOrders()}>
                        {TextManager.getCurrentTextResource().Text.save}
                    </Button>
                    <Button type="button" onClick={this.props.onClose} style={{marginRight: '20px'}}>
                        {TextManager.getCurrentTextResource().Text.cancel}
                    </Button>
                </ButtonToolbar>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        itemOrderInEdit: state.equipment.itemOrderInEdit,
        equipStore: state.equipment.data.equipStore,
        status: state.sales.status,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(EquipOrderManageJson))